import React, { useEffect } from 'react'
import styles from './styles.module.css'
import { useDispatch, useSelector } from 'react-redux'
import { useState } from 'react'
import Confirmation from '../../components/Confirmation/Confirmation'
import { Input, } from '../../components/ModalInputs'
import moment from 'moment'
import { getSecurityLogs } from '../../actions/securityLog'
import Empty from '../../components/Empty'
import Table from '../../components/Table'


const dateFormat = 'YYYY-MM-DD'; // Тип даты
const defaultDate = { date_from: moment(new Date()).format(dateFormat), date_to: moment(new Date()).format(dateFormat) }; // Дата по умолчани


export default function SecurityLog() {
  const dispatch = useDispatch()
  const { securityLogslist, loading } = useSelector(state => state.security_log)

  const [date, setDate] = useState(defaultDate); // Дата для поиска

  useEffect(() => {
    date.date_to && dispatch(getSecurityLogs(date))
  }, [date])

  const renderLi = (data) => {
    const { computername, fromip, issue_time, messagetype, subsystem, username, id } = data
    return (
      <tr >
        <td>{issue_time}</td>
        <td>{fromip}</td>
        <td>{computername}</td>
        <td>{subsystem}</td>
        <td>{username}</td>
        <td>{messagetype}</td>
      </tr>
    )
  }

  const dateChangeHandler = (name, value) => { // Обработчик изменения дат
    setDate({ ...date, [name]: moment(value).format(dateFormat) });
  }

  return (
    <div className={styles.wrapper} style={{ width: '1200px', margin: '0 auto' }}>
      <h1>Журнал безопастности</h1>
      <div className={styles.inputsRow}>
        <span className={styles.label}>Просмотр </span>
        <span className={styles.label}>c</span>
        <Input type='date' value={date.date_from} onChange={(e) => dateChangeHandler('date_from', e.target.value)} />
        <span className={styles.label}>по</span>
        <Input type='date' value={date.date_to} onChange={(e) => dateChangeHandler('date_to', e.target.value)} />
      </div>
      <div className={styles.inputsColumn}>
        {!loading && !securityLogslist?.length
          ? <Empty />
          : <Table className={styles.tables}>
            <thead>
              <tr>
                <th>Время</th>
                <th>IP</th>
                <th>Компьютер</th>
                <th>Подсистема</th>
                <th>Пользователь</th>
                <th>Сообщения</th>
              </tr>
            </thead>
            <tbody>
              {securityLogslist?.map(renderLi)}
            </tbody>
          </Table>}
      </div>


    </div>
  )
}
